// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.section_comments {
  max-width: 100%;
}
.section_comments .comments {
  margin: 0 auto;
  max-width: 1200px;
}
.section_comments .comments .control_link {
  margin: 30px 0;
}
.section_comments .comments .comments_titles {
  text-align: center;
  color: rgb(50, 50, 50);
  font-family: "Century Gothic";
  font-size: 3rem;
  font-weight: 300;
  line-height: 4rem;
}
@media screen and (max-width: 480px) {
  .section_comments .comments .comments_titles {
    padding: 0 20px;
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}
.section_comments .comments .comments_text {
  margin: 0 auto;
  max-width: 800px;
  text-align: center;
  color: rgb(49, 49, 49);
  font-family: "Roboto-Light";
  font-size: 14px;
  font-weight: 300;
  line-height: 1.3em;
}
@media screen and (max-width: 480px) {
  .section_comments .comments .comments_text {
    padding: 0 10px;
  }
}
.section_comments .comments .comments_carousel {
  text-align: center;
}
@media screen and (max-width: 480px) {
  .section_comments .comments .comments_carousel {
    margin: 30px 0;
  }
}
.section_comments .comments .comments_carousel img {
  margin: 0 20px;
  max-width: 250px;
}
@media screen and (max-width: 991px) {
  .section_comments .comments .comments_carousel img {
    max-width: 300px;
  }
}
@media screen and (max-width: 480px) {
  .section_comments .comments .comments_carousel img {
    max-width: 250px;
    height: auto;
  }
}
@media screen and (max-width: 991px) {
  .section_comments .comments .comments_carousel img:last-child {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .section_comments .comments .comments_carousel img:first-child {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/components/CommentsBlock/CommentsBlock.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;AAVA;EACI,eAAA;AAYJ;AAXI;EACI,cAAA;EACA,iBAAA;AAaR;AAXQ;EACI,cAAA;AAaZ;AAVQ;EACI,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAYZ;AAVY;EARJ;IASQ,eAAA;IACA,kBAAA;IACA,kBAAA;EAad;AACF;AAVQ;EACA,cAAA;EACI,gBAAA;EAEA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAWZ;AATY;EAXJ;IAYQ,eAAA;EAYd;AACF;AATQ;EACI,kBAAA;AAWZ;AATY;EAHJ;IAIQ,cAAA;EAYd;AACF;AAVY;EACI,cAAA;EACA,gBAAA;AAYhB;AAVgB;EAJJ;IAKQ,gBAAA;EAalB;AACF;AAXgB;EARJ;IASQ,gBAAA;IACA,YAAA;EAclB;AACF;AAXY;EACI;IACI,aAAA;EAalB;AACF;AAVY;EACI;IACI,aAAA;EAYlB;AACF","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n.section_comments {\n    max-width: 100%;\n    .comments {\n        margin: 0 auto;\n        max-width: 1200px;\n    \n        .control_link {\n            margin: 30px 0;\n        }\n    \n        .comments_titles {\n            text-align: center;\n            color: rgb(50, 50, 50);\n            font-family: \"Century Gothic\";\n            font-size: 3rem;\n            font-weight: 300;\n            line-height: 4rem;\n\n            @media screen and (max-width: 480px) {\n                padding: 0 20px;\n                font-size: 1.56rem;\n                line-height: 1.2em;\n            }\n        }\n    \n        .comments_text {\n        margin: 0 auto;\n            max-width: 800px;\n            //  max-width: 1200px;\n            text-align: center;\n            color: rgb(49, 49, 49);\n            font-family: \"Roboto-Light\";\n            font-size: 14px;\n            font-weight: 300;\n            line-height: 1.3em;\n\n            @media screen and (max-width: 480px) {\n                padding: 0 10px;\n            }\n        }\n    \n        .comments_carousel {\n            text-align: center;\n\n            @media screen and (max-width: 480px) {\n                margin: 30px 0;\n            }\n    \n            img {\n                margin: 0 20px;\n                max-width: 250px;\n\n                @media screen and (max-width: 991px) {\n                    max-width: 300px;\n                }\n\n                @media screen and (max-width: 480px) {\n                    max-width: 250px;\n                    height: auto;\n                }\n            }\n\n            @media screen and (max-width: 991px) {\n                img:last-child  {\n                    display: none;\n                }\n            }\n\n            @media screen and (max-width: 767px) {\n                img:first-child  {\n                    display: none;\n                }\n            }\n        }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
